import { Map, List } from "immutable";
import { DECISIONING_DASHBOARD_ACTIONS } from "../constants/actions";
import { STATE_STATUS } from "constants";

const INITIAL_STATE = new Map({
    columns: new Map({}),
    rows: new Map({})
});

export default (state=INITIAL_STATE, action={}) => {
    const { payload, type } = action;
    switch(type) {
    case DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_COLUMNS: {
        return state
            .setIn(["columns", "status"], STATE_STATUS.FETCHING);
    }
    case DECISIONING_DASHBOARD_ACTIONS.FETCHED_DECISIONING_DASHBOARD_COLUMNS:
        return state
            .setIn(["columns", "status"], STATE_STATUS.FETCHED)
            .setIn(["columns", "data"], new List(payload.columns));
            
    case DECISIONING_DASHBOARD_ACTIONS.FAILED_FETCH_DECISIONING_DASHBOARD_COLUMNS:
        return state
            .setIn(["columns", "error"], STATE_STATUS.FETCH_FAILED);

    case DECISIONING_DASHBOARD_ACTIONS.FETCH_DECISIONING_DASHBOARD_ROWS: {
        return state
            .setIn(["rows", "filters"], payload.filters)
            .setIn(["rows", payload.page, "data"], new List([]))
            .setIn(["rows", payload.page, "status"], STATE_STATUS.FETCHING);
    }
    case DECISIONING_DASHBOARD_ACTIONS.FETCHED_DECISIONING_DASHBOARD_ROWS:
        return state
            .setIn(["rows", payload.page, "status"], STATE_STATUS.FETCHED)
            .setIn(["rows", payload.page, "data"], new List(payload.rows.data))
            .setIn(["rows", "count"], payload.rows.total);
            
    case DECISIONING_DASHBOARD_ACTIONS.FAILED_FETCH_DECISIONING_DASHBOARD_ROWS:
        return state
            .setIn(["rows", payload.page, "error"], STATE_STATUS.FETCH_FAILED);

    default:
        return state;
    }
};
